import {
  LockCancelled,
  LockLockedSolid,
  LockUnlockedSolid,
  LockUnlockedRateRequested,
  LockLockedRateRequested,
  LockedExtensionRequested,
  LockCancelledNewLockReq,
  LockExpired,
} from '@elliemae/ds-icons';
import { DSIconSizes, DSIconColors } from '@elliemae/ds-icon';
import { RateRequestStatus } from '../../../../../common/constants/enumTypes';
import { useOriginalLoanInformationSelector } from '../../../../../data/useSelectors';

export const getLookupValue = (lookup, type, defaultValue) => {
  if (!lookup) return defaultValue;
  const item = lookup.filter((elem) => elem.value === type);
  return item ? item[0]?.key || item[0]?.label : defaultValue;
};

export const getLockStatusDetails = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { rateLock } = useOriginalLoanInformationSelector() as any;
  const { rateRequestStatus } = rateLock || {};

  const lockedCommonProps = {
    style: { paddingTop: '2px' },
    size: DSIconSizes.S,
  };

  const unlockedProps = {
    color: DSIconColors.WARNING,
    ...lockedCommonProps,
  };
  const lockedProps = { color: DSIconColors.PRIMARY, ...lockedCommonProps };
  const lockExpiredProps = { color: DSIconColors.DANGER, ...lockedCommonProps };
  const lockedCancelledProps = {
    color: ['neutral', '200'],
    ...lockedCommonProps,
  };

  switch (rateRequestStatus) {
    case RateRequestStatus.NotLockedNoRequest:
      return {
        lockStatusValue: 'Not Locked',
        lockIcon: <LockUnlockedSolid {...unlockedProps} />,
      };
    case RateRequestStatus.NotLockedRequest:
      return {
        lockStatusValue: 'Lock Requested',
        lockIcon: <LockUnlockedRateRequested {...unlockedProps} />,
      };
    case RateRequestStatus.LockedNoRequest:
      return {
        lockStatusValue: 'Locked',
        lockIcon: <LockLockedSolid {...lockedProps} />,
      };
    case RateRequestStatus.LockedRequest:
      return {
        lockStatusValue: 'Locked, New Lock Requested',
        lockIcon: <LockLockedRateRequested {...lockedProps} />,
      };
    case RateRequestStatus.LockedExtensionRequest:
      return {
        lockStatusValue: 'Locked, Extension Requested',
        lockIcon: <LockedExtensionRequested {...lockedProps} />,
      };
    case RateRequestStatus.LockedCancellationRequest:
      return {
        lockStatusValue: 'Locked, Cancellation Requested',
        lockIcon: <LockCancelledNewLockReq {...lockedCancelledProps} />,
      };
    case RateRequestStatus.Cancelled:
      return {
        lockStatusValue: 'Lock Cancelled',
        lockIcon: <LockCancelled {...lockedCancelledProps} />,
      };
    case RateRequestStatus.ExpiredNoRequest:
      return {
        lockStatusValue: 'Expired',
        lockIcon: <LockExpired {...lockExpiredProps} />,
      };
    case RateRequestStatus.ExpiredRequest:
      return {
        lockStatusValue: 'Expired, New Lock Requested',
        lockIcon: <LockExpired {...lockExpiredProps} />,
      };
    case RateRequestStatus.ExpiredExtensionRequest:
      return {
        lockStatusValue: 'Expired, Extension Requested',
        lockIcon: <LockedExtensionRequested {...lockedProps} />,
      };

    default:
      return {
        lockStatusValue: 'Voided',
        lockIcon: <LockCancelled {...lockedCancelledProps} />,
      };
  }
};
